import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDownload, FiTrash2, FiLoader } = FiIcons;

const UrlInput = ({ url, setUrl, onExtract, onClear, loading, error }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onExtract();
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          Extract Thumbnails
        </h2>
        <p className="text-gray-600">
          Paste a video URL to extract and download its thumbnails
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="relative">
          <input
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://youtube.com/watch?v=..."
            className="w-full px-4 py-4 text-lg border-2 border-gray-300 rounded-xl focus:border-indigo-500 focus:outline-none transition-colors"
            disabled={loading}
          />
          {url && (
            <button
              type="button"
              onClick={onClear}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors"
            >
              <SafeIcon icon={FiTrash2} className="text-xl" />
            </button>
          )}
        </div>

        {error && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700"
          >
            {error}
          </motion.div>
        )}

        <motion.button
          type="submit"
          disabled={loading || !url.trim()}
          className="w-full bg-indigo-600 text-white py-4 px-6 rounded-xl font-semibold text-lg hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center space-x-2"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          {loading ? (
            <>
              <SafeIcon icon={FiLoader} className="animate-spin" />
              <span>Extracting...</span>
            </>
          ) : (
            <>
              <SafeIcon icon={FiDownload} />
              <span>Extract Thumbnails</span>
            </>
          )}
        </motion.button>
      </form>
    </div>
  );
};

export default UrlInput;